import React from "react";
import {
    loadStripe,
    StripeCardElementChangeEvent,
    Stripe as StripeClient,
} from "@stripe/stripe-js";
import {
    CardElement,
    Elements,
    ElementsConsumer,
} from "@stripe/react-stripe-js";

import World from "../../world";
import { Submit } from "../Submit";
import LogoContainer from "../LogoContainer";
import styles from "./Stripe.module.scss";

export interface Props {
    world: World;
    stripe_pub_key: string;
    onSuccess: (string, number) => Promise<string>;
}

export interface State {
    is_pending: boolean;
    payment_intent_client_secret?: string;
    price?: number;
    amount?: number;
    discount?: number;
    error?: string;
}

export default class Stripe extends React.Component<Props, State> {
    private stripe: Promise<StripeClient>

    constructor(props: Props) {
        super(props);

        this.state = {
            is_pending: true,
        };

        this.stripe = loadStripe(props.stripe_pub_key);

        props.world.createPaymentIntent()
            .then(([pi, err]) => {
                if (err) {
                    this.setState({
                        error: "Currently unavailable",
                        is_pending: false,
                    });
                    return
                }
                this.setState({ 
                    payment_intent_client_secret: pi.client_secret,
                    price: pi.price,
                    amount: pi.amount,
                    discount: pi.discount,
                    is_pending: false,
                });
            });
    }

    public handleSubmit(stripe: any, elements: any): (e: React.FormEvent<HTMLFormElement>) => Promise<void> {
        return async (e: React.FormEvent<HTMLFormElement>) => {
            if (!stripe || !elements) {
                return;
            }
            e.preventDefault();

            this.setState({ error: "", is_pending: true });
 
            const payload = await stripe.confirmCardPayment(this.state.payment_intent_client_secret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                },
            });

            if (payload.error) {
                this.setState({
                    error: `Payment failed: ${payload.error.message}`,
                    is_pending: false,
                });
                return;
            }

            const err = await this.props.onSuccess(payload.paymentIntent.id, this.state.amount / 100);
            if (err) {
                this.setState({error: err, is_pending: false});
                return;
            }
            this.setState({is_pending: false});
        };
    }

    public handleChange = (e: StripeCardElementChangeEvent) => {

    }

    private label(): string {
        if (!this.state.amount) {
            return "";
        }

        const dollars = this.state.amount / 100;
        let text = "Pay ";

        // 2 decimal places unless it's a whole number
        if (Math.floor(dollars) === dollars) {
            text = `$${dollars}`;
        } else {
            text = `$${dollars.toFixed(2)}`;
        }

        if (this.state.discount) {
            text += ` (${this.state.discount}% Saved)`
        }

        return text;
    }

    public render() {
        return (
            <div className={styles["payment-form"]}>
                <LogoContainer />

                <h2>Payment Info</h2>

                <br />
                <p className="form-error">{this.state.error}</p>

                <Elements stripe={this.stripe}>
                    <ElementsConsumer>
                    {({ stripe, elements }) => (
                        <form id="stripe" onSubmit={this.handleSubmit(stripe, elements)}>
                            <CardElement id="card-element" onChange={this.handleChange} />

                            <br />
                            <Submit label={this.label()} is_pending={this.state.is_pending} />
                        </form>
                    )}
                    </ElementsConsumer>
                </Elements>

                <img src="/img/secure-stripe-payment-logo-bw2.png" className={styles["payment-icons"]} />
            </div>
        );
    }
}


